<template>
  <div id="app">
    <PlaceLoading v-if="loading"/>
    <PlaceNotFound v-if="!loading && notFound"/>
    <PlaceHeader :place="place" v-if="!loading && !notFound && place.name && place.name != ''"/>
    <Search :place="place" v-if="!loading && !notFound && place.place_id"/>
    <PlaceFooter :place="place" v-if="!loading && !notFound && place.name && place.name != '' && place.use_footer"/>
  </div>
</template>

<script>
import './assets/styles/main.css'
import PlaceService from './service/place'
import PlaceHeader from './components/PlaceHeader.vue'
import PlaceLoading from './components/PlaceLoading.vue'
import PlaceNotFound from './components/PlaceNotFound.vue'
import Search from './components/Search.vue'
import PlaceFooter from './components/PlaceFooter.vue'

export default {
  name: 'OrderCheck',
  components: {
    PlaceHeader,
    PlaceLoading,
    PlaceNotFound,
    Search,
    PlaceFooter
  },
  data() {
    return {
      place: {
        name: ''
      },
      notFound: false,
      loading: false
    }
  },
  methods: {
    //Fetch place info
    fetchPlace(){
      this.notFound = false
      this.loading = true
      PlaceService.getPlace().then(response => {
        this.loading = false
        if (!response) {
          this.notFound = true
        } else {
          this.place = response
        }
      })
    }
  },
  mounted() {
    this.fetchPlace()
  }
}
</script>

<style lang="scss">
#app {
}
</style>
